import babs from "url:../../assets/cnn/frm/babs.png";
import egg from "url:../../assets/cnn/frm/egg.png";
import honse from "url:../../assets/cnn/frm/honse.png";
import mask from "url:../../assets/cnn/frm/mask.png";
import nyan from "url:../../assets/cnn/frm/nyanyakon.png";
import yea from "url:../../assets/cnn/frm/profilepics_0000_yea.jpg";
import scribe from "url:../../assets/cnn/frm/profilepics_0001_Scribe 1.jpg";
import television from "url:../../assets/cnn/frm/profilepics_0002_Television - Ill.jpg";
import group2 from "url:../../assets/cnn/frm/profilepics_0003_Group 2.jpg";
import creature from "url:../../assets/cnn/frm/profilepics_0004_Creature 03 copy.jpg";
import fairy from "url:../../assets/cnn/frm/profilepics_0005_Fairy 046.jpg";
import actor from "url:../../assets/cnn/frm/profilepics_0006_Actor - Child 1.jpg";
import layer4 from "url:../../assets/cnn/frm/profilepics_0007_Layer 4.jpg";
import candle from "url:../../assets/cnn/frm/profilepics_0008_Book & Candle.jpg";
import cheese from "url:../../assets/cnn/frm/profilepics_0009_Cheese - Dazed.jpg";
import books from "url:../../assets/cnn/frm/profilepics_0010_Books - Cartoon.jpg";
import castle from "url:../../assets/cnn/frm/profilepics_0011_Castle - Crystal Ball.jpg";
import drinking from "url:../../assets/cnn/frm/profilepics_0012_Drinking - Baby_s Bottle.jpg";
import cassette from "url:../../assets/cnn/frm/profilepics_0013_Audio Cassette 03.jpg";
import layer2 from "url:../../assets/cnn/frm/profilepics_0014_Layer 2.jpg";
import minotaur from "url:../../assets/cnn/frm/profilepics_0015_Minotaur 1.jpg";
import broom from "url:../../assets/cnn/frm/profilepics_0016_Creature with Broom.jpg";
import mermaid from "url:../../assets/cnn/frm/profilepics_0017_Mermaid - Cat.jpg";
import page5 from "url:../../assets/cnn/frm/profilepics_0018_Page 5.jpg";
import group1 from "url:../../assets/cnn/frm/profilepics_0019_Group 1.jpg";
import mask2 from "url:../../assets/cnn/frm/profilepics_0020_Mask 2.jpg";
import clown from "url:../../assets/cnn/frm/profilepics_0021_Clown 26.jpg";
import default_icon from 'url:../../assets/cnn/frm/topic.png';

export function GetIcon(icon: string)
{
    switch (icon)
    {
        case "babs": return babs;
        case "egg": return egg;
        case "honse": return honse;
        case "mask": return mask;
        case "nyan": return nyan;
        case "yea": return yea;
        case "scribe": return scribe;
        case "television": return television;
        case "group2": return group2;
        case "creature": return creature;
        case "fairy": return fairy;
        case "actor": return actor;
        case "layer4": return layer4;
        case "candle": return candle;
        case "cheese": return cheese;
        case "books": return books;
        case "castle": return castle;
        case "drinking": return drinking;
        case "cassette": return cassette;
        case "layer2": return layer2;
        case "minotaur": return minotaur;
        case "broom": return broom;
        case "mermaid": return mermaid;
        case "page5": return page5;
        case "group1": return group1;
        case "mask2": return mask2;
        case "clown": return clown;
    }
    return default_icon;
}